<div class="titles-wrapper">
    <div class="title-container">
        <p>Background</p>
        <input class="colorpicker-input mt-2" [(ngModel)]="topbar.background"
        [value]="topbar.background"
        [style.background]="topbar.background"
        [(colorPicker)]="topbar.background">
    </div>
    <div class="title-container">
        <p>Label</p>
        <input class="colorpicker-input mt-2" [(ngModel)]="topbar.label"
        [value]="topbar.label"
        [style.background]="topbar.label"
        [(colorPicker)]="topbar.label">
    </div>
    <div class="title-container">
        <p>ID</p>
        <input class="colorpicker-input mt-2" [(ngModel)]="topbar.value"
        [value]="topbar.value"
        [style.background]="topbar.value"
        [(colorPicker)]="topbar.value">
    </div>
</div>